module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "old-card.e2c5ac0c.png";